/* eslint-disable prefer-arrow-callback, no-undef, no-console */

import { Modal, RadioAdvanced } from '@gameday/react-components/components'

import { RadioGroup } from '@material-ui/core'
import Delete from '@material-ui/icons/Delete'
import { useEffect, useState } from 'react'

import Checkbox from '../../../../factories/components/checkbox'
import NavigationButtons from '../../Common/NavigationButton'
import styles from './styles.scss'

const PaypalComponent = ({
  onError = () => {},
  onSuccess = () => {},
  currency,
  showLoadingIndicator,
  onChangeGateway,
  clientToken,
  getClientToken,
  braintreeId,
  total,
  paymentMethods,
  getPaymentMethods,
  deletePayPalToken,
  clearError,
  isFetchFailed,
  isGuestSignup,
  buttonColour,
  buttonTextColour,
}) => {
  const [dropInError, setDropInError] = useState(false)
  const [isPayPalVault, setPayPalVault] = useState(false)
  const [showCheckbox, setShowCheckbox] = useState(false)
  const [selectedPayPalAccount, setSelectedPayPalAccount] = useState(null)
  const [payPalAccountToDelete, setPayPalAccountToDelete] = useState(null)
  const [showModal, setShowModal] = useState(false)

  const createPayPalButton = vaultEnabled => {
    if (!clientToken) {
      getClientToken(!!braintreeId)
    }
    showLoadingIndicator(true)
    braintree.client.create(
      {
        authorization: clientToken,
      },
      (clientErr, clientInstance) => {
        if (clientErr) {
          console.error('Error creating client:', clientErr)
          setDropInError(true)
          return
        }

        braintree.paypalCheckout.create(
          {
            client: clientInstance,
          },
          (paypalCheckoutErr, paypalCheckoutInstance) => {
            if (paypalCheckoutErr) {
              console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
              setDropInError(true)
              return
            }

            paypalCheckoutInstance.loadPayPalSDK(
              {
                ...(vaultEnabled ? { vault: true } : {}),
                ...(vaultEnabled ? {} : { currency }),
                ...(vaultEnabled ? {} : { intent: 'capture' }),
              },
              () => {
                const button = paypal.Buttons({
                  fundingSource: paypal.FUNDING.PAYPAL,
                  createOrder: !vaultEnabled
                    ? () =>
                        paypalCheckoutInstance.createPayment({
                          flow: 'checkout',
                          amount: total,
                          currency,
                          intent: 'capture',
                        })
                    : undefined,
                  createBillingAgreement: vaultEnabled
                    ? () =>
                        paypalCheckoutInstance.createPayment({
                          flow: 'vault',
                        })
                    : undefined,
                  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
                  onApprove: (data, actions) => {
                    showLoadingIndicator(true)
                    return paypalCheckoutInstance.tokenizePayment(data, (err, payload) => {
                      if (err) {
                        onError()
                      }

                      onSuccess(payload)
                    })
                  },
                  onCancel: () => {
                    showLoadingIndicator(false)
                  },
                  onError: () => {
                    onError()
                  },
                  onClick: () => {
                    setSelectedPayPalAccount(null)
                  },
                })

                if (button.isEligible()) {
                  button.render('#paypal-button')
                  showLoadingIndicator(false)
                  setShowCheckbox(true)
                } else {
                  setDropInError(true)
                }
              }
            )
          }
        )
      }
    )
  }

  const onDeletePayPal = () => {
    deletePayPalToken({ token: payPalAccountToDelete.token, type: 'paypal' })
  }

  useEffect(() => {
    if (!currency) {
      return
    }

    if (!clientToken) {
      getClientToken(!!braintreeId)
    } else if (clientToken) {
      createPayPalButton(isPayPalVault)
    }
  }, [clientToken])

  useEffect(() => {
    showLoadingIndicator(true)
    getPaymentMethods({ type: 'paypal' })
  }, [])

  useEffect(() => {
    setSelectedPayPalAccount(paymentMethods[0])
    showLoadingIndicator(false)
  }, [paymentMethods])

  return (
    <>
      {dropInError ? (
        <p>
          {`Error Loading PayPal, Click "Back"
        and navigate back to Payment Page.`}
        </p>
      ) : (
        <div>
          {paymentMethods.length > 0 && (
            <div>
              <RadioGroup>
                {/** biome-ignore lint/correctness/noUnusedFunctionParameters: TODO */}
                {paymentMethods.map((paymentMethod, index) => (
                  <RadioAdvanced
                    label={paymentMethod.email}
                    name="payment"
                    size="small"
                    value={paymentMethod.token}
                    key={paymentMethod.token}
                    checked={selectedPayPalAccount ? selectedPayPalAccount.token === paymentMethod.token : false}
                    onClick={() => {
                      setSelectedPayPalAccount(paymentMethod)
                    }}
                    actionIcon={<Delete />}
                    onClickAction={() => {
                      setPayPalAccountToDelete(paymentMethod)
                      setShowModal(true)
                    }}
                    className={`radio-advanced ${
                      selectedPayPalAccount ? selectedPayPalAccount.token === paymentMethod.token && 'active' : ''
                    }`}
                  />
                ))}
              </RadioGroup>
              {showCheckbox && (
                <p style={{ textAlign: 'center', fontSize: '12px' }}>or choose another payment method</p>
              )}
            </div>
          )}
          <div id="paypal-button" />
          {showCheckbox && !isGuestSignup && (
            <Checkbox
              label="Save new PayPal account for future use"
              onChange={value => {
                clearError()
                setPayPalVault(value)
                createPayPalButton(value)
              }}
              value={isPayPalVault}
            />
          )}
          {showModal && (
            <Modal
              saveButtonClassName={styles.removeModalButton}
              label="Delete Saved PayPal Account"
              isShowSaveButton
              isShowBottomBar
              isOpen={showModal}
              handleModalClose={() => {
                setPayPalAccountToDelete(null)
                setShowModal(false)
              }}
              handleModalSubmit={() => {
                onDeletePayPal()
              }}
              okText="Delete"
            >
              {`Are you sure you want to delete the saved account: "${payPalAccountToDelete.email}"?`}
            </Modal>
          )}
        </div>
      )}

      <NavigationButtons
        hideSubmitButton={paymentMethods.length === 0 || isFetchFailed}
        preventDefaultOnBack
        hideHr
        nonStick
        onBack={onChangeGateway}
        submitLabel="Pay Now"
        onSubmit={() => {
          onSuccess({
            paymentToken: selectedPayPalAccount.token,
          })
        }}
        isContinueDisabled={!selectedPayPalAccount}
        buttonColour={buttonColour}
        buttonTextColour={buttonTextColour}
      />
    </>
  )
}

export default PaypalComponent
